import React from 'react'
import { connect } from 'react-redux'
import AttractionPromoActions from '../../Redux/AttractionPromoRedux'
import Select from 'react-select'

class Update extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        country_id: props.detail.country_id || '',
        name: props.detail.name || '',
        coupon_code: props.detail.coupon_code || '',
        url: props.detail.url || '',
        description: props.detail.description || '',
        discount_amount: props.detail.discount_amount || ''
      },
      selectedCountry: props.selectedCountry
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let uuid = this.props.detail.id
    let form = { ...this.state.form }
    let data = { uuid, form }
    this.props.put(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  _selectChange = (selectedCountry, field) => {
    let form = { ...this.state.form }
    form[field] = selectedCountry.value
    this.setState({
      selectedCountry,
      form
    })
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    let value = event.target.value
    form[field] = value
    this.setState({ form })
  }

  _selectRow = (field) => {
    const { dataCountries } = this.props
    let countrySelector = []
    dataCountries.map((item, i) => (
      countrySelector[i] = {
        value: item.id,
        label: item.name
      }
    ))
    return (
      <Select
        required
        options={countrySelector}
        value={this.state.selectedCountry}
        onChange={(selectedCountry) => this._selectChange(selectedCountry, field)}
      />
    )
  }

  _inputRow = (properties, field) => {
    return (
      <input
        className='form-control'
        type={properties.type}
        required={properties.required}
        min={properties.min}
        max={properties.max}
        minLength={properties.minLength}
        maxLength={properties.maxLength}
        placeholder={properties.placeholder}
        value={this.state.form[field]}
        onChange={(event) => this._inputChange(event, field)}
      />
    )
  }

  _formRow = (type, properties, label, field) => {
    switch (type) {
      case 'input':
        return (
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>{label}</label>
            </div>
            <div className='col-9'>
              { this._inputRow(properties, field) }
            </div>
          </div>
        )
      case 'select':
        return (
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>{label}</label>
            </div>
            <div className='col-9'>
              { this._selectRow(field) }
            </div>
          </div>
        )
      default:
        return null
    }
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw' }}>
        <header className='title-block'>
          <h1 className='title'>
            Update Attraction Promo
            <small className='form-text text-muted'>{this.props.detail.name}</small>
          </h1>
        </header>
        <form onSubmit={(event) => this._submit(event)}>
          { this._formRow('select', null, 'Country', 'country_id') }
          { this._formRow('input', { type: 'text', required: true, placeholder: 'Promo name' }, 'Name', 'name') }
          { this._formRow('input', { type: 'text', placeholder: 'Coupon code (7 letters max)', minLength: 4, maxLength: 7 }, 'Coupon Code', 'coupon_code') }
          { this._formRow('input', { type: 'text', required: true, placeholder: 'Must be https://' }, 'URL', 'url') }
          { this._formRow('input', { type: 'text' }, 'Promo description', 'description') }
          { this._formRow('input', { type: 'text' }, 'Discount', 'discount_amount') }
          <div className='form-group d-flex justify-content-end'>
            <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
            <button className='btn btn-lg btn-primary' type='submit'>Submit</button>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  dataCountries: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  put: (data) => dispatch(AttractionPromoActions.putAttractionPromoRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Update)



// WEBPACK FOOTER //
// ./src/Containers/AttractionPromo/Update.js